import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../notifications/notification.service';
import { AuthTokenService } from './auth-token.service';

export const SESSION_EXPIRED_TITLE = 'Sesión expirada';
export const SESSION_EXPIRED_MESSAGE = 'Tu sesión ha expirado. Inicia sesión nuevamente.';

@Injectable({ providedIn: 'root' })
export class SessionLogoutService {
  private readonly authTokenService = inject(AuthTokenService);
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);

  forceLogout(): void {
    this.authTokenService.clearToken();
    this.notificationService.warning(SESSION_EXPIRED_MESSAGE, { title: SESSION_EXPIRED_TITLE });
    this.router.navigate(['/']);
  }
}
